import React from "react";
import useStyles from "./style";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Slide,
  DialogActions,
  Typography,
  Button,
  IconButton,
  Divider,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const ViewFiles = ({
  openDialog,
  handleClose,
  documentData,
  onDeleteDocument,
  onApproveDocument,
}) => {
  const classes = useStyles();

  const filePath = documentData?.file || "";
  const fileName = documentData?.fileName || documentData?.documentType || "Document";
  const shouldShowApprove = documentData?.status !== "APPROVED";

  return (
    <Dialog
      open={openDialog}
      TransitionComponent={Transition}
      keepMounted
      onClose={handleClose}
      maxWidth={"md"}
      aria-describedby="dialog-box"
      className={classes.root}
    >
      <DialogTitle>
        <section className={classes.dialogTitleContainer}>
          <Typography variant="body1" className={classes.title}>
            View a file
          </Typography>
          <IconButton aria-label="close" onClick={handleClose}>
            <CloseIcon className={classes.closeIcon} />
          </IconButton>
        </section>
      </DialogTitle>
      <DialogContent>
        <div className={classes.uploadAreaWrapper}>
          {filePath ? (
            <div className={classes.previewDocumentWrapper}>
              <Typography>Preview Document</Typography>
              <iframe
                title={fileName}
                src={filePath}
                className={classes.documentViewerWrapper}
              />
            </div>
          ) : (
            <Typography variant="body2" sx={{ color: "#7a7272" }}>
              No file available for preview.
            </Typography>
          )}
        </div>
      </DialogContent>
      <Divider />
      <DialogActions>
        <section className={classes.dialogActions}>
          <section className={classes.closeBtn}>
            <Button onClick={handleClose} style={{ marginRight: "10px" }}>
              Close
            </Button>
          </section>
          <section className={classes.closeBtn}>
            <Button
              onClick={() => onDeleteDocument?.(documentData)}
              style={{ marginRight: "10px" }}
            >
              Delete
            </Button>
          </section>
          {shouldShowApprove && (
            <section className={classes.approveBtn}>
              <Button onClick={() => onApproveDocument?.(documentData)}>
                Approve
              </Button>
            </section>
          )}
        </section>
      </DialogActions>
    </Dialog>
  );
};

export default ViewFiles;
